import React, { lazy } from 'react';
import { Phone, CheckCircle2, MapPin, Camera, Star, ShieldCheck, Clock, Wrench, Instagram } from 'lucide-react';
const LOGO_FF = 'https://cdn.magicpatterns.com/uploads/4vu93MmquQP5WtFpD5B3fW/ME028a73f42dd035a5a2bf395c0a492227.png';
const LOGO_PHONE = 'https://cdn.magicpatterns.com/uploads/oeSbPuRHwgR6iCP3dAry88/ME1b941892e4c9062d7d520e34ad61e526.png';
const INSTAGRAM_URL = 'https://www.instagram.com/floridaframeless/';
const PROJECTS = [{
  src: 'https://cdn.magicpatterns.com/uploads/c6h3U1oVuRCjDxV5eARqC2/ff1.jpg',
  alt: 'Frameless glass shower with blue onyx marble tile and gold hardware'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/d1EZnAfNc9fFqcX9MvcA65/ff2.jpg',
  alt: 'Frameless corner shower with gray vertical tile and matte black hardware'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/voXapD3tpdzuBj6qpFTWoR/ff3.jpg',
  alt: 'Walk-in frameless shower with dramatic gray marble tile and pebble floor'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vUwiro5PhxKtMdjjqQGm6N/ff4.jpg',
  alt: 'Frameless shower with blue vertical tile, hexagon floor and gold hardware'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/48bGmBovWezaFV6ASWsTaj/ff5.jpg',
  alt: 'Frameless corner shower with white marble hexagon tile and bench seat'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fH6gTnYzVdPKGzXLgKw56X/ff6.jpg',
  alt: 'Frameless neo-angle shower with white marble tile, freestanding tub and black hardware'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vZ1JGs3Kr3KYqND2uB3u7W/ff7.jpg',
  alt: 'Frameless sliding tub enclosure with blue tile and gold hardware'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nhtVNMKU1Vbgkgz4XYWrS1/ff8.jpg',
  alt: 'Dual rain-head walk-in shower with freestanding tub and pebble floor'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/i29zg1FW1Q3uYUuENwoquR/ff9.jpg',
  alt: 'Black-framed glass wine room partition with hardwood floor'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cht8esiQqENM6iGMTRFRh5/ff10.jpg',
  alt: 'Frameless corner shower with white subway tile, bench and hexagon floor'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2VjiZyfJ7aPQqfXRJ91rao/ff11.jpg',
  alt: 'Frameless sliding shower door with white subway tile and gold hardware'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rPi9YWpZWkVZ4SzEArKtPe/ff13.jpg',
  alt: 'Frameless walk-in shower with tan marble tile, bench and gold hardware'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/n1aFiBKU8gH3AmSv8yrTz5/ff14.jpg',
  alt: 'Frameless tub enclosure with gray subway tile and glass panel screen'
}];
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-gold selection:text-black" data-id="element-0">
      {/* Sticky Top Bar */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-brand-gold/20" data-id="element-1">
        <div className="container mx-auto px-4 h-20 flex items-center justify-between" data-id="element-2">
          <div className="flex items-center gap-3" data-id="element-3">
            <img src={LOGO_FF} alt="Florida Frameless" className="h-14 w-auto" data-id="element-4" />
            <div className="hidden md:block" data-id="element-5">
              <h1 className="font-condensed font-bold italic text-2xl tracking-wide leading-none" data-id="element-6">
                FLORIDA FRAMELESS
              </h1>
              <p className="text-brand-gold font-condensed font-semibold tracking-widest text-sm" data-id="element-7">
                SHOWER & BATH
              </p>
            </div>
          </div>
          <a href="tel:772-631-2774" className="flex items-center gap-2 bg-brand-gold hover:bg-yellow-400 text-black px-5 py-2.5 rounded-full font-condensed font-bold italic text-xl transition-transform hover:scale-105" data-id="element-8">
            <Phone size={20} className="animate-pulse" data-id="element-9" />
            <span className="hidden sm:inline" data-id="element-10">CALL OR TEXT:</span> 772-631-2774
          </a>
        </div>
      </div>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 relative overflow-hidden bg-brand-dark" data-id="element-11">
        {/* Brand-consistent diagonal accent (matches the black & gold ad graphics) */}
        <div className="absolute inset-0 opacity-[0.06] pointer-events-none" style={{
        backgroundImage: 'repeating-linear-gradient(135deg, #FFB800 0px, #FFB800 2px, transparent 2px, transparent 22px)'
      }} data-id="element-12" />
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold/10 blur-[120px] rounded-full pointer-events-none" data-id="element-13" />

        <div className="container mx-auto relative z-10 max-w-3xl text-center" data-id="element-14">
          <h2 className="font-condensed font-black italic text-6xl md:text-8xl leading-[0.85] mb-6 drop-shadow-2xl" data-id="element-15">
            <span className="text-white block" data-id="element-16">OUTDATED</span>
            <span className="text-white block" data-id="element-17">SHOWER?</span>
            <span className="text-brand-gold block mt-2" data-id="element-18">GO FRAMELESS</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 font-medium mb-8 max-w-2xl mx-auto" data-id="element-19">
            Local Trusted Glass Experts Serving the Treasure Coast & Palm Beach.
            Beautiful Showers. Built Right.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center" data-id="element-20">
            <a href="tel:772-631-2774" className="w-full sm:w-auto flex items-center justify-center gap-3 bg-brand-gold text-black px-8 py-4 rounded-lg font-condensed font-bold italic text-2xl hover:bg-yellow-400 transition-colors" data-id="element-21">
              <Camera size={28} data-id="element-22" />
              TEXT A PHOTO FOR A FAST FREE QUOTE!
            </a>
          </div>

          <div className="mt-8 flex items-center justify-center gap-6 text-sm font-semibold text-gray-400" data-id="element-23">
            <div className="flex items-center gap-2" data-id="element-24">
              <Star className="text-brand-gold" size={18} data-id="element-25" /> 5-Star Rated
            </div>
            <div className="flex items-center gap-2" data-id="element-26">
              <ShieldCheck className="text-brand-gold" size={18} data-id="element-27" /> Fully
              Insured
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-brand-gray border-y border-white/5" data-id="element-28">
        <div className="container mx-auto px-4" data-id="element-29">
          <div className="text-center mb-16" data-id="element-30">
            <h3 className="font-condensed font-bold italic text-4xl md:text-5xl text-brand-gold mb-4" data-id="element-31">
              OUR SERVICES
            </h3>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-32">
              Expert glass installations tailored to your space. We handle
              everything from simple doors to complete bathroom transformations.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-33">
            {[{
            title: 'FRAMELESS SHOWER DOORS',
            icon: <Wrench size={32} data-id="element-34" />,
            desc: 'Custom measured and expertly installed frameless enclosures that make your bathroom feel larger and more luxurious.'
          }, {
            title: 'OFFICE GLASS PARTITIONS',
            icon: <ShieldCheck size={32} data-id="element-35" />,
            desc: 'Modernize your workspace with sleek, sound-dampening glass walls and doors for a professional environment.'
          }, {
            title: 'TUB TO SHOWER CONVERSIONS',
            icon: <Clock size={32} data-id="element-36" />,
            desc: 'Transform your old, unused tub into a stunning, accessible walk-in shower in as little as 2 days.'
          }].map((service, i) => <div key={i} className="bg-brand-dark p-8 rounded-xl border border-white/10 hover:border-brand-gold/50 transition-colors group" data-id="element-37">
                <div className="text-brand-gold mb-6 group-hover:scale-110 transition-transform origin-left" data-id="element-38">
                  {service.icon}
                </div>
                <h4 className="font-condensed font-bold italic text-2xl mb-3" data-id="element-39">
                  {service.title}
                </h4>
                <p className="text-gray-400 leading-relaxed" data-id="element-40">{service.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Choose Us & Van */}
      <section className="py-20 overflow-hidden relative" data-id="element-41">
        <div className="container mx-auto px-4" data-id="element-42">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-43">
            <div className="flex-1" data-id="element-44">
              <h3 className="font-condensed font-bold italic text-5xl md:text-6xl mb-8" data-id="element-45">
                WHY <span className="text-brand-gold" data-id="element-46">CHOOSE US?</span>
              </h3>

              <div className="space-y-6" data-id="element-47">
                {['FRAMELESS SPECIALISTS', 'EXPERT INSTALLATION', 'CLEAN, RESPECTFUL & RELIABLE', '2 DAY SHOWER REMODELS AVAILABLE', 'LOCALLY OWNED & OPERATED'].map((item, i) => <div key={i} className="flex items-center gap-4" data-id="element-48">
                    <div className="bg-brand-gold/10 p-2 rounded-full" data-id="element-49">
                      <CheckCircle2 className="text-brand-gold" size={24} data-id="element-50" />
                    </div>
                    <span className="font-condensed font-semibold tracking-wide text-xl md:text-2xl" data-id="element-51">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="mt-12 p-6 bg-brand-gold/10 border border-brand-gold/20 rounded-xl inline-block" data-id="element-52">
                <div className="flex items-center gap-3 mb-2" data-id="element-53">
                  <MapPin className="text-brand-gold" size={24} data-id="element-54" />
                  <h4 className="font-condensed font-bold italic text-2xl" data-id="element-55">
                    PROUDLY SERVING
                  </h4>
                </div>
                <p className="text-brand-gold font-semibold text-lg" data-id="element-56">
                  TREASURE COAST & PALM BEACH
                </p>
              </div>
            </div>

            <div className="flex-1 w-full relative" data-id="element-57">
              <div className="absolute -inset-3 bg-brand-gold/15 blur-2xl rounded-full pointer-events-none" data-id="element-58" />
              <img src={PROJECTS[2].src} alt={PROJECTS[2].alt} className="relative z-10 w-full rounded-2xl shadow-2xl border-4 border-brand-gold/30 object-cover aspect-[3/4] max-h-[560px]" data-id="element-59" />
            </div>
          </div>
        </div>
      </section>

      {/* Gallery / Real Projects */}
      <section className="py-20 bg-brand-gray" data-id="element-60">
        <div className="container mx-auto px-4" data-id="element-61">
          <div className="text-center mb-12" data-id="element-62">
            <h3 className="font-condensed font-bold italic text-4xl md:text-5xl mb-4" data-id="element-63">
              SEE OUR <span className="text-brand-gold" data-id="element-64">WORK</span>
            </h3>
            <p className="text-gray-400 text-lg" data-id="element-65">
              Real frameless showers we've designed and installed across the
              Treasure Coast & Palm Beach.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto auto-rows-[220px] md:auto-rows-[280px]" data-id="element-66">
            {PROJECTS.map((project, i) => <div key={i} className={`group relative overflow-hidden rounded-xl border border-white/10 hover:border-brand-gold/60 transition-colors ${i === 0 ? 'col-span-2 row-span-2' : ''}`} data-id="element-67">
                <img src={project.src} alt={project.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-68" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-69" />
              </div>)}
          </div>

          <div className="text-center mt-12" data-id="element-70">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 border border-brand-gold/40 text-brand-gold hover:bg-brand-gold hover:text-black px-6 py-3 rounded-full font-condensed font-bold italic text-xl transition-colors" data-id="element-71">
              <Instagram size={22} data-id="element-72" />
              SEE MORE ON INSTAGRAM
            </a>
          </div>
        </div>
      </section>

      {/* Footer CTA */}
      <footer className="bg-black pt-20 pb-10 border-t border-white/10" data-id="element-73">
        <div className="container mx-auto px-4 text-center" data-id="element-74">
          <img src={LOGO_PHONE} alt="Call Now" className="h-24 mx-auto mb-8" data-id="element-75" />
          <h2 className="font-condensed font-black italic text-5xl md:text-7xl mb-6" data-id="element-76">
            READY FOR YOUR <span className="text-brand-gold" data-id="element-77">FREE QUOTE?</span>
          </h2>
          <p className="text-xl text-gray-400 mb-10 max-w-2xl mx-auto" data-id="element-78">
            Take a quick photo of your current shower or bathroom space and text
            it to us. We'll get back to you fast with a free, no-obligation
            quote!
          </p>

          <a href="tel:772-631-2774" className="inline-flex items-center gap-4 bg-brand-gold text-black px-10 py-5 rounded-xl font-condensed font-bold italic text-3xl hover:bg-yellow-400 transition-all hover:scale-105 shadow-[0_0_40px_rgba(255,184,0,0.3)]" data-id="element-79">
            <Phone size={32} className="animate-pulse" data-id="element-80" />
            772-631-2774
          </a>

          <div className="mt-16 flex justify-center" data-id="element-81">
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Follow Florida Frameless on Instagram" className="inline-flex items-center gap-2 text-gray-300 hover:text-brand-gold transition-colors font-condensed font-semibold tracking-wide text-lg" data-id="element-82">
              <Instagram size={22} data-id="element-83" />
              @floridaframeless
            </a>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-gray-500 text-sm" data-id="element-84">
            <p data-id="element-85">
              © {new Date().getFullYear()} Florida Frameless Shower Doors. All
              rights reserved.
            </p>
            <p data-id="element-86">GoFramelessNOW.com</p>
          </div>
        </div>
      </footer>

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-0 left-0 right-0 p-4 bg-black/90 backdrop-blur-md border-t border-white/10 md:hidden z-50" data-id="element-87">
        <a href="tel:772-631-2774" className="flex items-center justify-center gap-2 bg-brand-gold text-black w-full py-3 rounded-lg font-condensed font-bold italic text-xl" data-id="element-88">
          <Phone size={20} data-id="element-89" />
          CALL OR TEXT NOW
        </a>
      </div>
    </div>;
}